import React from 'react';
import { useMutation } from 'react-fetching-library';
import { Modal, Stack, Card, CardContent, Typography, Button } from '@mui/material';
import { duplicateOrderAction } from '../../../../services/request';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const ConfirmOrderDuplicate = ({ order, open, handleClose, addOrder }) => {
  const { loading, mutate } = useMutation(duplicateOrderAction);

  const handleSubmit = async () => {
    const { error, payload } = await mutate(order.id);
    if (!error) {
      addOrder(payload);
      handleClose();
    } else {
      toast.error('Nie udało się zduplikować zamówienia');
    }
  };

  return (
    <Modal open={open} onClose={handleClose} >
      <Card sx={{ ...style, width: '25vw', height: '25vh' }}>
        <CardContent sx={{ height: '100%' }}>
          <Stack direction="column" sx={{ height: '100%' }}>
            <Typography variant="h4" textAlign="center">
              Czy na pewno chcesz zduplikować zamówienie {order.identifier} ?
            </Typography>
            <Stack direction="row" justifyContent="space-around" alignItems="end" flexGrow={1}>
              <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Anuluj</Button>
              <Button sx={{ flexGrow: 0.4 }} variant="contained" onClick={handleSubmit} disabled={loading}>Duplikuj</Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  );
};


export default ConfirmOrderDuplicate;
